import { render, staticRenderFns } from "./woman.vue?vue&type=template&id=3f8cec63&scoped=true&"
import script from "./woman.vue?vue&type=script&lang=ts&"
export * from "./woman.vue?vue&type=script&lang=ts&"
import style0 from "./woman.vue?vue&type=style&index=0&id=3f8cec63&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8cec63",
  null
  
)

export default component.exports